<template>
	<div class="field" :class="classes">
		<label v-html="label" :for="getName()"></label>

		<template v-if="element == 'textarea'">
			<textarea v-model="value" :required="getRequired()" :name="getName()" :id="getName()" :placeholder="placeholder"></textarea>
		</template>

		<input v-else-if="element == 'input'" :type="type" v-model="value" :required="getRequired()" :name="getName()" :id="getName()" :placeholder="placeholder"/>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				value: ''
			}
		},

		props: {
			fieldId: {
				type: Number,
				required: true
			},

			type: {
				type: String,
				required: true
			},

			label: {
				type: String,
				default: '',
			},

			placeholder: {
				type: String,
				default: '',
			},

			classes: {
				type: String,
				default: '',
			},

			required: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			element() {
				switch (this.type) {
					case 'textarea':
						return 'textarea';
					default:
						return 'input';
				}
			}
		},

		watch: {
			value(val) {
				this.$emit('input', val);
			}
		},

		mounted() {
			$(this.$el).find('input, textarea').blur(function(e) {
				$(this).parents('.field').removeClass('error');
			});
		},

		methods: {
			getRequired() {
				return this.required ? 'required' : 'false';
			},

			getName() {
				return `input_${this.fieldId}`;
			}
		}
	}
</script>
